import React, { useEffect, useState } from 'react';

import { useHistory } from 'react-router-dom';

import PageSettingApi from 'Api/CRM/Modules/PageSettingApi';
import PageSettings from 'Api/Models/PageSettings';
import Loader from 'crm/elements/Loader';
import SweetAlert from 'crm/elements/alerts/SweetAlert';
import FormSwitchSelector from 'crm/elements/formElements/FormSwitchSelector';
import handleValidationErrors, { ValidationErrors } from 'crm/helpers/ResponseErrorHelper';
import useBlockingSubmit from 'crm/hooks/useBlockingSubmit';

interface HideElementSettingsProps {
    field: string;
    label: string;
    settingKey: string;
}
const HideElementSettings: React.FC<HideElementSettingsProps> = ({ field, label, settingKey }) => {
    const history = useHistory();
    const [Submit, submitBlocked] = useBlockingSubmit();
    const [isLoading, setIsLoading] = useState(true);
    const [item, setItem] = useState<PageSettings>(new PageSettings({ key: settingKey, value: '' }));
    const [, setErrors] = useState<ValidationErrors>({});

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await SweetAlert.loader(PageSettingApi.update(item));
            await SweetAlert.success('Page settings updated correctly');
            history.push('/page-settings');
        } catch (error) {
            handleValidationErrors(error, setErrors);
            submitBlocked(false);
        }
    };

    const handleSwitchSelectorChange = (value: string) => {
        setItem(new PageSettings({ key: settingKey, value }));
    };

    useEffect(() => {
        PageSettingApi.getByKey(settingKey)
            .then((response) => {
                setItem(new PageSettings({ key: settingKey, value: response.value }));
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    const options = [
        {
            label: 'Hide',
            value: '0',
            selectedBackgroundColor: '#de1a24',
            innerHeight: 50,
        },
        {
            label: 'Show',
            value: '1',
            selectedBackgroundColor: '#3f8f29',
        },
    ];

    const getContent = () => {
        return (
            <div className="form-flex">
                <form onSubmit={handleSubmit}>
                    <FormSwitchSelector
                        label={label}
                        handleChange={handleSwitchSelectorChange}
                        options={options}
                        currentValue={item.value}
                        required
                        field={field}
                        error={undefined}
                    />
                    <Submit label="Update" />
                </form>
            </div>
        );
    };

    return <Loader loading={isLoading} content={getContent} />;
};

export default HideElementSettings;
